import { atom } from 'jotai';

import { $defaultView } from './preferences.state';

import { $facilityId } from '~/shared/providers/auth/identity.localState';
import { atomFromQueryString } from '~/shared/state';

export type CalendarView = 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay';

const VALID_VIEWS: CalendarView[] = [
  'dayGridMonth',
  'timeGridWeek',
  'timeGridDay',
];

const $calendarViewParam = atomFromQueryString.string('view');

export const $calendarView = atom(
  (get): CalendarView => {
    const urlParam = get($calendarViewParam);
    if (urlParam && VALID_VIEWS.includes(urlParam as CalendarView)) {
      return urlParam as CalendarView;
    }
    const saved = get($defaultView) as CalendarView;
    if (VALID_VIEWS.includes(saved)) {
      return saved;
    }
    return 'dayGridMonth';
  },
  (get, set, value: CalendarView) => {
    set($calendarViewParam, value);
    set($defaultView, value);
  },
);

export const $calendarDate = atomFromQueryString.string('date');

export const $selectedFacilityId = $facilityId;
